import { Page } from "@/models/page-models/Page";

export const GroupSalesVariance: Page = {
  "path": "group-sales-variance",
  "name": "Group Sales Variance",
  "props": {
    "data": {
      "title": "Group Sales Variance",
      "printable": "FALSE",
      "url": "group-sales-variance",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2024,2025,2026,2027]",
                  "dropdownType": "static",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToGroupSalesVariance",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/group-sales-variance",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"year\":\"{{formData.year}}\"}"
                      },
                      "name": "redirectToGroupSalesVariance"
                    }
                  ]
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "salesVariance",
                  "showIf": "{{fetchedData.varianceData.data}}",
                  "varianceDataVariable": "fetchedData.varianceData.data",
                  "mode": "customer"
                }
              ],
              "showIf": "{{fetchedData.varianceData.data}}",
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.varianceData.data.status}},'),==,'Approved')"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultGroupVarianceForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultGroupVarianceForm",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultGroupVarianceForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "loadSalesVarianceData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-forecast/group-sales-variance",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.varianceData",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "loadSalesVarianceData"
      }
    ],
    "functions": [
      {
        "name": "getDefaultGroupVarianceForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{CURRENT_YEAR}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 70
}